<template>
  <BaseDetailLayout :title="`${fleetModule.driver} Details`">
    <template #action></template>
    <template #detail>
      <v-row no-gutters class="ma-0 pa-3">
        <v-col cols="12" md="3" lg="3" class="d-flex flex-column">
          <v-card elevation="0" class="mb-4 rounded-lg">
            <v-row no-gutters v-if="driverDetail.driver_details" class="pa-2">
              <v-col
                cols="12"
                md="3"
                lg="4"
                class="pa-2"
                v-if="driverDetail.profile_image"
              >
                <v-img contain :src="driverDetail.profile_image" />
              </v-col>
              <v-col class="pa-2" cols="12" md="3" lg="4" v-else>
                <v-img :src="driverImage" contain />
              </v-col>
              <v-col cols="12" md="7" lg="8" class="py-2 app-relative">
                <div
                  v-if="permissions.change"
                  style="
                    text-decoration: none;
                    position: absolute;
                    top: -5px;
                    right: -5px;
                  "
                  class="mr-2"
                >
                  <v-icon
                    class="primary--text"
                    small
                    @click="
                      $router.push({
                        name: 'edit-driver',
                        params: {
                          id: $route.params.id,
                        },
                      })
                    "
                    >mdi-pencil</v-icon
                  >
                </div>

                <div>
                  <h4 v-if="driverDetail.driver_details.full_name">
                    <BaseTooltip
                      title="full name"
                      :text="driverDetail.driver_details.full_name"
                    />
                  </h4>
                  <div class="text-subtitle-1 font-weight-bold d-flex">
                    <h5
                      class="text_color--text"
                      v-if="driverDetail.driver_details.username"
                    >
                      <BaseTooltip
                        title="user name"
                        :text="driverDetail.driver_details.username"
                      />
                    </h5>
                    <span class="px-3">|</span>
                    <h5
                      class="text_color--text"
                      style="text-transform: capitalize"
                      v-if="driverDetail.driver_details.contact_number"
                    >
                      <BaseTooltip
                        title="contact number"
                        :text="driverDetail.driver_details.contact_number"
                      />
                    </h5>
                  </div>
                </div>
                <v-row no-gutters>
                  <v-col cols="6" v-if="driverDetail.driver_details.branch">
                    <h5 class="text_color--text">
                      {{ configurationModule.branch }}
                    </h5>
                  </v-col>
                  <v-col cols="6">
                    <h5
                      class="text_color--text"
                      v-if="driverDetail.driver_details.branch"
                    >
                      <BaseTooltip
                        title="branch"
                        :text="driverDetail.driver_details.branch"
                      />
                    </h5>
                  </v-col>
                  <v-col
                    cols="6"
                    v-if="driverDetail.driver_details.vehicle_number"
                  >
                    <h5 class="text_color--text">Vehicle</h5>
                  </v-col>
                  <v-col cols="6">
                    <h5
                      class="text_color--text"
                      v-if="driverDetail.driver_details.vehicle_number"
                    >
                      <BaseTooltip
                        title="vehicle number"
                        :text="driverDetail.driver_details.vehicle_number"
                      />
                    </h5>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>

          <v-card elevation="0" class="rounded-lg">
            <v-card-title class="px-3 py-1">
              <v-row no-gutters>
                <v-col cols="6">
                  <h6>{{ fleetModule.driver }} Details</h6>
                </v-col>
                <v-col cols="6" class="text-right">
                  <a
                    v-if="permissions.view"
                    class="primary--text text-caption"
                    @click="documentUploadFormDialog = true"
                  >
                    View Document
                  </a>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-subtitle>
              <div
                v-if="driverDetail && driverDetail.driver_details"
                class="overflow-y-auto"
                :style="
                  driverDetail && driverDetail.custom_fields
                    ? 'height: calc(100vh - 665px)'
                    : 'height: calc(100vh - 405px)'
                "
              >
                <v-row
                  no-gutters
                  v-for="(value, key, index) in driverDetail.driver_details"
                  :key="index"
                  class="pt-1 px-2"
                >
                  <v-col md="5" lg="6" v-if="value">
                    <h5 class="text_color--text text-capitalize">
                      {{ key.replace(/_/g, " ") }}
                    </h5>
                  </v-col>
                  <v-col md="7" lg="6">
                    <h5>{{ value }}</h5>
                  </v-col>
                </v-row>
              </div>
            </v-card-subtitle>
          </v-card>

          <v-card
            elevation="0"
            class="rounded-lg mt-4"
            v-if="driverDetail && driverDetail.custom_fields"
          >
            <v-card-title class="px-3 py-1">
              <v-row no-gutters>
                <v-col cols="12">
                  <h6>Extra Information</h6>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-subtitle>
              <div class="overflow-y-auto" style="height: 170px">
                <div
                  v-for="(value, key, index) in driverDetail.custom_fields"
                  :key="index"
                  class="pt-1 px-2"
                >
                  <v-row no-gutters>
                    <v-col cols="6">
                      <h5 class="text-left text-capitalize" v-if="key">
                        {{ key.replace(/_/g, "  ") }}
                      </h5>
                    </v-col>
                    <v-col cols="6">
                      <h6
                        class="text-caption black--text text-center"
                        v-if="Array.isArray(value)"
                      >
                        <div
                          v-for="(itemKey, itemIndex) in value"
                          :key="itemIndex"
                        >
                          <v-chip x-small class="success px-2 text-capitalize">
                            {{ itemKey }}
                          </v-chip>
                        </div>
                      </h6>
                      <h6
                        class="text-caption black--text text-center"
                        v-else-if="typeof value == 'boolean'"
                      >
                        <v-icon small :color="value ? 'success' : 'error'">
                          {{ value ? "mdi-check-circle" : "mdi-close-circle" }}
                        </v-icon>
                      </h6>
                      <h6 class="text-caption black--text text-center" v-else>
                        {{ value }}
                      </h6>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" lg="6">
          <v-card
            class="d-flex flex-column h-100 background_color"
            elevation="0"
          >
            <v-row
              no-gutters
              v-if="driverDetail && driverDetail.driver_analytics"
              class="pb-3 px-3"
            >
              <v-col
                v-for="(value, key, index) in driverDetail.driver_analytics"
                :key="index"
                class="px-1 pb-1"
              >
                <v-card elevation="0" class="h-100 rounded-lg">
                  <v-card-text
                    class="px-4 py-2 h-100 d-flex flex-column justify-space-between"
                  >
                    <span
                      class="text_color--text text-capitalize text-center text-caption font-weight-bold d-flex justify-center"
                    >
                      {{ key.replace(/_/g, " ") }}
                    </span>

                    <div class="d-flex align-center justify-space-around">
                      <v-icon :color="driverAnalyticsColor[key]">
                        {{ driverAnalyticsIcon[key] }}</v-icon
                      >

                      <span class="text-caption">
                        <h3 class="text-nowrap">{{ value }}</h3>
                      </span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <div class="px-4 h-100">
              <v-card
                elevation="0"
                v-if="!isVisibleTripDetails"
                class="h-100 rounded-lg"
              >
                <v-row no-gutters class="h-100">
                  <v-col cols="6" class="d-flex align-center pl-2">
                    <h4 class="text-capitalize text-subtitle-2">
                      {{ tripModule.tripPlural }}
                    </h4>
                  </v-col>
                  <v-col cols="6">
                    <v-tabs v-model="tab" right class="rounded-lg">
                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Today
                        </h4>
                      </v-tab>

                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Last 7 days
                        </h4>
                      </v-tab>
                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Next 7 days
                        </h4>
                      </v-tab>
                    </v-tabs>
                  </v-col>
                  <v-col cols="12">
                    <AgGridVue
                      @grid-ready="gridReady"
                      :grid-options="gridOptions"
                      :column-defs="tableHeader"
                      :default-col-def="defaultColDef"
                      :row-data="tripList"
                      :context="context"
                      style="width: 100%; height: calc(100vh - 355px)"
                      class="ag-theme-balham px-4 pt-4"
                    >
                    </AgGridVue>
                  </v-col>
                  <v-col
                    cols="6"
                    class="pl-3 d-flex justify-start align-center"
                  >
                    <PaginationCount :total="totalCount" />
                  </v-col>
                  <v-col cols="6" class="d-flex justify-end">
                    <Pagination
                      :pageNo="pageNo"
                      :totalItems="totalCount"
                      :pageSize="itemsPerPage"
                      @itemsPerPageChange="itemsPerPageChange"
                      @prevPage="prevPage"
                      @nextPage="nextPage"
                    />
                  </v-col>
                </v-row>
              </v-card>
              <v-card
                elevation="0"
                class="rounded-lg"
                v-else
                style="height: calc(100vh - 245px)"
              >
                <v-row no-gutters>
                  <v-col cols="6" class="d-flex align-center pl-2">
                    <v-icon
                      small
                      @click="isVisibleTripDetails = false"
                      class="mx-3"
                      >mdi-arrow-left</v-icon
                    >
                    <h4 class="text-capitalize text-subtitle-2">
                      {{ tripModule.trip }} details
                    </h4>
                  </v-col>
                  <v-col cols="6" class="rounded-lg">
                    <v-tabs v-model="tabDetails" right class="rounded-lg">
                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Details
                        </h4>
                      </v-tab>
                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Map
                        </h4>
                      </v-tab>
                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Logs
                        </h4>
                      </v-tab>
                    </v-tabs>
                  </v-col>
                  <v-col cols="12" class="pa-0 mx-0 background_color">
                    <v-card
                      elevation="0"
                      class="card-box-shadow px-4 py-0 mb-7"
                    >
                      <v-row v-if="tripDetails && tripDetails.trip_details">
                        <v-col cols="8" class="d-flex align-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <h2
                                class="mr-2 text-capitalize"
                                v-if="tripDetails.trip_details.reference_number"
                                v-bind="attrs"
                                v-on="on"
                              >
                                {{ tripDetails.trip_details.reference_number }}
                              </h2>
                            </template>
                            <span class="text-capitalize"
                              >reference number</span
                            >
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                class="mr-1 text-capitalize white--text font-weight-bold"
                                x-small
                                :class="
                                  $helper.tripStatusColor(
                                    tripDetails.status.toLowerCase()
                                  )
                                "
                                v-if="tripDetails.status"
                                v-bind="attrs"
                                v-on="on"
                              >
                                {{ tripDetails.status }}
                              </v-chip>
                            </template>
                            <span class="text-capitalize"
                              >{{ tripModule.trip }} status</span
                            >
                          </v-tooltip>
                        </v-col>
                        <v-col
                          cols="4"
                          class="text-right d-flex justify-end align-center"
                        >
                          <div
                            class="mr-4"
                            v-if="tripDetails.trip_details.trip_date"
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <h5
                                  v-bind="attrs"
                                  v-on="on"
                                  class="mr-2 text-capitalize"
                                  v-if="tripDetails.trip_details.trip_date"
                                >
                                  {{ tripDetails.trip_details.trip_date }}
                                </h5>
                              </template>
                              <span>{{ tripModule.trip }} Date</span>
                            </v-tooltip>
                          </div>

                          <div
                            class=""
                            v-if="
                              tripDetails &&
                              tripDetails.trip_details &&
                              tripDetails.trip_details.branch
                            "
                          >
                            <v-chip dense class="primary">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <h5
                                    v-bind="attrs"
                                    v-on="on"
                                    class="text-capitalize text-center"
                                    v-if="tripDetails.trip_details.branch"
                                  >
                                    {{ tripDetails.trip_details.branch }}
                                  </h5>
                                </template>
                                <span
                                  >{{ configurationModule.branch }} Name</span
                                >
                              </v-tooltip>
                            </v-chip>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>

                    <v-card
                      elevation="0"
                      class="card-box-shadow pa-3 my-3 rounded-lg"
                    >
                      <v-row no-gutters class="pb-2">
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="tripDetails.asset_details.driver.name"
                        >
                          <TripTooltipWithIcon
                            icon="mdi-account"
                            :text="tripDetails.asset_details.driver.name"
                            label="driver name"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="tripDetails.asset_details.driver.contact_number"
                        >
                          <TripTooltipWithIcon
                            icon="mdi-phone"
                            :text="
                              tripDetails.asset_details.driver.contact_number
                            "
                            label="driver contact number"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="tripDetails.asset_details.driver.shift_timing"
                        >
                          <TripTooltipWithIcon
                            icon="mdi-timer"
                            :text="
                              tripDetails.asset_details.driver.shift_timing
                            "
                            label="shift timing"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="
                            tripDetails.asset_details.vehicle.vehicle_number
                          "
                        >
                          <TripTooltipWithIcon
                            icon="mdi-truck"
                            :text="
                              tripDetails.asset_details.vehicle.vehicle_number
                            "
                            label="vehicle number"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="
                            tripDetails.asset_details.vehicle.tonnage_capacity
                          "
                        >
                          <TripTooltipWithIcon
                            icon="mdi-weight"
                            :text="
                              tripDetails.asset_details.vehicle.tonnage_capacity
                            "
                            label="vehicle tonnage capacity"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="tripDetails.asset_details.vehicle.cbm_capacity"
                        >
                          <TripTooltipWithIcon
                            icon="mdi-cube"
                            :text="
                              tripDetails.asset_details.vehicle.cbm_capacity
                            "
                            label="vehicle cbm capacity"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="
                            tripDetails &&
                            tripDetails.item_details &&
                            $helper.isCompanyHasItems()
                          "
                        >
                          <TripTooltipWithIcon
                            icon="mdi-white-balance-sunny"
                            :text="tripDetails.item_details.dry_items"
                            label="Dry Items"
                            iconColor="orange"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="
                            tripDetails &&
                            tripDetails.item_details &&
                            $helper.isCompanyHasItems()
                          "
                        >
                          <TripTooltipWithIcon
                            icon="mdi-snowflake"
                            :text="tripDetails.item_details.frozen_items"
                            label="Frozen Items"
                            iconColor="blue"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="
                            tripDetails &&
                            tripDetails.item_details &&
                            $helper.isCompanyHasItems()
                          "
                        >
                          <TripTooltipWithIcon
                            icon="mdi-ice-pop"
                            :text="tripDetails.item_details.chilled_items"
                            label="Chilled"
                            iconColor="red"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="
                            tripDetails &&
                            tripDetails.order_details &&
                            tripDetails.order_details.basic &&
                            tripDetails.order_details.basic.total_items
                          "
                        >
                          <TripTooltipWithIcon
                            icon="mdi-alpha-i-box"
                            :text="tripDetails.order_details.basic.total_items"
                            label="Total items"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="
                            tripDetails &&
                            tripDetails.order_details &&
                            tripDetails.order_details.basic &&
                            tripDetails.order_details.basic.total_orders
                          "
                        >
                          <TripTooltipWithIcon
                            icon="mdi-archive"
                            :text="tripDetails.order_details.basic.total_orders"
                            label="Total Orders"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="
                            tripDetails &&
                            tripDetails.order_details &&
                            tripDetails.order_details.basic &&
                            tripDetails.order_details.basic.volume
                          "
                        >
                          <TripTooltipWithIcon
                            icon="mdi-cube"
                            :text="tripDetails.order_details.basic.volume"
                            label="volume"
                          />
                        </v-col>
                        <v-col
                          cols="3"
                          class="pb-1"
                          v-if="
                            tripDetails &&
                            tripDetails.order_details &&
                            tripDetails.order_details.basic &&
                            tripDetails.order_details.basic.weight
                          "
                        >
                          <TripTooltipWithIcon
                            icon="mdi-weight"
                            :text="tripDetails.order_details.basic.weight"
                            label="weight"
                          />
                        </v-col>
                      </v-row>
                    </v-card>

                    <v-tabs-items v-model="tabDetails" class="mt-4 rounded-lg">
                      <v-tab-item style="height: calc(100vh - 510px)">
                        <v-card elevation="0" class="w-100 rounded-lg">
                          <TripOrders
                            :tripId="tripDetails.id"
                            :status="tripDetails.status"
                          />
                        </v-card>

                        <!-- <v-card
                            elevation="0"
                            v-if="tripDetails && tripDetails.extra_information"
                            class="w-100 rounded-lg"
                          >
                            <v-card-title
                              class="py-1 d-flex justify-space-between"
                            >
                              <v-row no-gutters>
                                <v-col cols="4"></v-col>
                                <v-col cols="4">
                                  <h5
                                    class="
                                      text-caption text-center
                                      font-weight-bold
                                    "
                                  >
                                    Planned Trip
                                  </h5>
                                </v-col>
                                <v-col cols="4">
                                  <h5
                                    class="
                                      text-caption text-center
                                      font-weight-bold
                                    "
                                  >
                                    Actual Trip
                                  </h5>
                                </v-col>
                              </v-row>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-subtitle>
                              <v-row
                                no-gutters
                                v-for="(
                                  value, key, index
                                ) in tripDetails.extra_information"
                                :key="index"
                                class="py-1"
                              >
                                <v-col cols="4">
                                  <h5
                                    class="text-left text-capitalize"
                                    v-if="key"
                                  >
                                    {{ key.replace(/_/g, "  ") }}
                                  </h5>
                                </v-col>
                                <v-col cols="4">
                                  <h6
                                    class="text-caption black--text text-center"
                                  >
                                    {{ value.planned ? value.planned : "-" }}
                                  </h6>
                                </v-col>
                                <v-col cols="4">
                                  <h6
                                    class="text-caption black--text text-center"
                                  >
                                    {{ value.actual ? value.actual : "-" }}
                                  </h6>
                                </v-col>
                              </v-row>
                            </v-card-subtitle>
                          </v-card> -->
                      </v-tab-item>
                      <v-tab-item>
                        <GoogleMap
                          :hasMapInfo="true"
                          mapHeight="calc(100vh - 520px)"
                          mapWidth="100%"
                          ref="tripMap"
                        >
                          <template #mapInfo>
                            <MapInfo
                              legendType="trip"
                              :actualRoute="actualRoute"
                              :plannedRoute="plannedRoute"
                              :referenceElement="$refs.tripMap"
                            />
                          </template>
                        </GoogleMap>
                      </v-tab-item>
                      <v-tab-item
                        style="height: calc(100vh - 510px)"
                        class="overflow-y-auto"
                      >
                        <Logs :logs="TripLogs" />
                      </v-tab-item>
                    </v-tabs-items>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" lg="3">
          <section>
            <v-card elevation="0" class="rounded-lg">
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Logs</h6>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text
                class="overflow-y-auto"
                style="height: calc(100vh - 425px)"
              >
                <div v-scroll:#driver-log="onDriverLogsScroll">
                  <Logs :logs="driverLogs" />
                </div>
              </v-card-text>
            </v-card>

            <v-card elevation="0" class="h-100 rounded-lg mt-4">
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Assigned Zones</h6>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>

              <v-card-subtitle style="height: 170px" class="overflow-y-auto">
                <div
                  v-if="
                    driverDetail &&
                    driverDetail.assigned_zones &&
                    driverDetail.assigned_zones.length > 0
                  "
                >
                  <v-chip-group column>
                    <v-chip
                      small
                      :close="permissions.change"
                      close-icon="mdi-close"
                      v-for="(zone, index) in driverDetail.assigned_zones"
                      :key="index"
                      @click:close="deleteDriverZones(zone.id, index)"
                      >{{ zone.name }}</v-chip
                    >
                  </v-chip-group>
                </div>
                <v-row no-gutters v-else>
                  <v-col
                    cols="12"
                    class="d-flex justify-center algin-center pt-14 h-100"
                  >
                    <h5 class="font-weight-bold text_color--text">
                      No assigned zones at the moment.
                    </h5>
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-card>
          </section>
        </v-col>
      </v-row>
    </template>
    <template #dialog>
      <DocumentListForm
        moduleType="Driver"
        v-model="documentUploadFormDialog"
        :parentObj="driverDetail"
        @getList="getDriverDocuments"
      /> </template
  ></BaseDetailLayout>
</template>

<script>
import { bus } from "@/main.js";
import BaseDetailLayout from "@/components/LayoutComponents/BaseDetailLayout.vue";
import DialogBase from "@/components/BaseComponents/DialogBase.vue";
import Logs from "@/components/BaseComponents/Logs.vue";
import BaseSmallTripDetail from "@/components/BaseComponents/BaseSmallTripDetail.vue";
import DocumentListForm from "@/components/GeneralComponents/DocumentListForm.vue";
import driverImage from "@/assets/profile.jpg";
import BaseTooltip from "@/components/BaseComponents/BaseTooltip.vue";
import BaseDetails from "@/components/LayoutComponents/BaseDetails.vue";
import { AgGridVue } from "ag-grid-vue";
import Pagination from "@/components/BaseComponents/Pagination.vue";
import DriverTripDetailsButton from "@/components/Button/DriverTripDetailsButton.vue";
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import TripOrders from "@/components/ModuleBasedComponents/Trip/TripOrders.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import { getDateTime, returnToday } from "@/utils/functions";
import PaginationCount from "@/components/BaseComponents/PaginationCount.vue";
import {
  fleetModule,
  tripModule,
  orderModule,
  configurationModule,
} from "@/utils/moduleMapping";

export default {
  components: {
    BaseDetailLayout,
    DialogBase,
    Logs,
    BaseSmallTripDetail,
    DocumentListForm,
    BaseTooltip,
    BaseDetails,
    AgGridVue,
    Pagination,
    DriverTripDetailsButton,
    TripTooltipWithIcon,
    GoogleMap,
    TripOrders,
    MapInfo,
    PaginationCount,
  },
  data() {
    return {
      fleetModule,
      tripModule,
      orderModule,
      configurationModule,
      driverImage,
      tab: 0,
      tabDetails: 0,
      isVisibleTripDetails: false,
      driverDetail: {},
      userDetails: this.$helper.getUserDetailsLocalStorage(),
      defaultColDef: {
        lockPosition: true,
        flex: 1,
        resizable: true,
        sortable: true,
        autoHeight: true,
        cellStyle: {
          "text-overflow": "ellipsis",
          "white-space": "nowrap",
          overflow: "hidden",
          display: "block",
        },
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        headerHeight: 40,
        rowHeight: 40,
        rowSelection: "multiple",
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
      },
      tripList: [],
      showMore: false,
      driverDocuments: [],
      itemsPerPage: 10,
      pageNo: 1,
      driverAnalyticsColor: {
        average_delay_time: "pickedup",
        joined_on: "failed",
        last_days_trips: "on_hold",
        total_order: "trip_active",
        total_trips: "partially_delivered",
      },
      driverAnalyticsIcon: {
        average_delay_time: "mdi-timer",
        joined_on: "mdi-account-multiple-outline",
        last_seven_day_trips: "mdi-truck",
        total_order: "mdi-archive",
        total_trips: "mdi-truck-fast",
      },
      columnDefs: [
        {
          headerName: "reference number",
          headerTooltip: "Reference Number",
          field: "reference_number",
          pinned: "left",
          minWidth: 200,
        },
        {
          headerName: "Trip Date",
          field: "trip_date",
        },
        {
          headerName: "Vehicle",
          field: "vehicle",
        },
        {
          headerName: "Total Orders",
          field: "total_orders",
        },
        {
          headerName: "Status",
          field: "verbose_status",
        },
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          sortable: false,
          width: 100,
          cellRenderer: "DriverTripDetailsButton",
        },
      ],

      driverLogs: [],
      TripLogs: [],
      isDriverLogsScrollable: true,
      driverZoneLogs: [],

      showDocumentDialog: false,
      driverLogsTotalCount: 0,
      isDriverZoneLogsScrollable: true,
      totalCount: 0,
      documentUploadFormDialog: false,
      permissions: null,
      tripDetails: {},
      routeDetails: {},
      plannedRoute: null,
      actualRoute: null,
      tripFilter: {
        trip_date: returnToday(),
      },
    };
  },
  computed: {
    tableHeader() {
      if (this.$helper.isCompanyHasItems()) {
        this.columnDefs.splice(4, 0, {
          headerName: "Total Items",
          field: "total_order_items",
        });
      }
      return this.columnDefs;
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.itemsPerPage);
    },
    context() {
      return { parentComponent: this };
    },
  },
  watch: {
    tabDetails(val) {
      if (val == 0) {
      } else if (val == 1) {
        this.getTripRoute();
      } else if (val == 2) {
        this.getTripLog();
      }
    },
    tab(val) {
      if (val == 0) {
        this.tripFilter = {
          trip_date: returnToday(),
        };
        this.getTripList();
      } else if (val == 1) {
        this.tripFilter = {
          from_date: returnToday(-7),
          to_date: returnToday(-1),
        };
        this.getTripList();
      } else if (val == 2) {
        this.tripFilter = {
          from_date: returnToday(1),
          to_date: returnToday(7),
        };
        this.getTripList();
      }
    },
  },
  methods: {
    nextPage() {
      this.pageNo++;
      this.getTripList();
    },

    prevPage() {
      this.pageNo--;
      this.getTripList();
    },

    itemsPerPageChange(value) {
      this.pageNo = 1;
      this.itemsPerPage = value;
      this.getTripList();
    },

    gridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    getTripDetails(id) {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripDetails(id)
        .then(({ data }) => {
          this.tripDetails = data;
          this.isVisibleTripDetails = true;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getTripRoute() {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripRoute(this.tripDetails.id)
        .then((res) => {
          let timer = setTimeout(() => {
            if (this.$refs.tripMap) {
              this.$refs.tripMap.clearGeoJson();
              this.$refs.tripMap.clearDriverRoute();
              this.$refs.tripMap.clearMarker();

              // clearInterval(timer);
              this.routeDetails = {};
              this.routeDetails = res.data;

              this.$refs.tripMap.setPlannedRoute(
                this.routeDetails.planned_route
              );
              this.$refs.tripMap.setLocation(
                this.routeDetails.driver_last_location,
                "driver_live_location"
              );
              this.plannedRoute = res?.data?.planned_route;

              setTimeout(() => {
                if (
                  this.routeDetails &&
                  this.routeDetails.actual_route &&
                  this.routeDetails.actual_route.features &&
                  this.routeDetails.actual_route.features.length != 0 &&
                  this.routeDetails.actual_route.features[0].geometry &&
                  this.routeDetails.actual_route.features[0].geometry
                    .coordinates
                ) {
                  this.actualRoute =
                    this.routeDetails.actual_route.features[0].geometry.coordinates;
                  this.$refs.tripMap.setDriverRoute(this.actualRoute);
                  this.clearableRoute = true;
                }
              }, 50);
            }
          }, 400);

          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getTripLog() {
      this.$api.logs
        .getTripLogs({ trip: this.tripDetails.id, limit: "all" })
        .then((res) => {
          this.TripLogs = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onScroll() {
      this.scrollInvoked++;
    },
    onDriverLogsScroll(e) {
      console.log("scrolling");
      let scroll =
        parseInt(e.target.scrollHeight) -
        parseInt(e.target.scrollTop + e.target.clientHeight);
      if (scroll == 0 && this.driverLogsTotalCount != this.driverLogs.length) {
        this.getDriverLogs();
      }
    },
    deleteDocument(id) {
      // this.$root
      //   .$confirm("Delete?", "Are you sure you want to delete this document?", {
      //     color: "error",
      //   })
      //   .then((confirm) => {
      //     if (confirm) {
      //       this.$api.driver
      //         .deleteDocument(id)
      //         .then(() => {
      //           bus.$emit("showToastMessage", {
      //             message: "Document removed successfully",
      //             color: "success",
      //           });
      //           // this.driverDocuments?.data.splice(index, 1);
      //           this.getDriverDocuments();
      //         })
      //         .catch((err) => {
      //           console.error(err);
      //         });
      //     }
      //   });
    },
    getDriverDocuments(params = {}) {
      // params = {
      //   ...params,
      //   driver: this.$route.params.id,
      //   limit: this.itemsPerPage,
      //   offset: this.offset,
      // };
      // bus.$emit("showLoader", true);
      // this.$api.driver
      //   .getDriverDocuments(params)
      //   .then((res) => {
      //     bus.$emit("showLoader", false);
      //     this.driverDocuments = res.data;
      //     this.totalCount = res.count;
      //   })
      //   .catch((err) => {
      //     console.error(err);
      //     bus.$emit("showLoader", false);
      //   });
    },
    getDriverView(params = {}) {
      bus.$emit("showLoader", true);
      this.$api.driver
        .getDriverView(params)
        .then((res) => {
          this.driverDetail = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    deleteDriverZones(id, index) {
      this.$root
        .$confirm("Delete?", "Are you sure you want to delete this zone?", {
          color: "error",
        })
        .then((confirm) => {
          if (confirm) {
            this.$api.driver
              .deleteDriverZones(id)
              .then(() => {
                bus.$emit("showToastMessage", {
                  message: "driver assigned zone removed successfully",
                  color: "success",
                });
                if (
                  this.driverDetail &&
                  this.driverDetail.assigned_zones &&
                  this.driverDetail.assigned_zones.length > 0
                ) {
                  this.driverDetail.assigned_zones.splice(index, 1);
                }
              })
              .catch((err) => console.log(err));
          }
        });
    },
    getDriverLogs(reload) {
      let params = {
        offset: reload ? 0 : this.driverLogs.length,
        limit: 15,
        driver: this.$route.params.id,
      };

      bus.$emit("showLoader", true);

      this.$api.logs
        .getDriverLogs(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          if (reload) {
            this.driverLogs = res.data;
          } else {
            this.driverLogs = [...this.driverLogs, ...res.data];
          }
          this.driverLogsTotalCount = res.count;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getTripList(params = {}) {
      params = {
        ...params,
        ...this.tripFilter,
        offset: this.offset,
        limit: this.itemsPerPage,
        driver: this.$route.params.id,
      };

      if (this.search) {
        params.search = this.search;
      }
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.tripList = res.data;
          this.totalCount = res.count;
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  mounted() {
    if ("id" in this.$route.params) {
      this.getDriverView(this.$route.params.id);
      this.getTripList();
      this.getDriverLogs(true);
      // this.getDriverDocuments();
    }
  },
  created() {
    this.permissions = this.$permissions.getPermission("fleet");
  },
};
</script>

<style scoped>
.app-driver-font-tab {
  font-family: roboto;
  text-transform: capitalize;
  letter-spacing: 0.1px;
}
.main-drivers-layout {
  height: 100%;
}
.template-grid {
  display: grid;
  grid-template-columns: 400px 1fr 400px;
  grid-column-gap: 8px;
  height: calc(100vh - 130px);
}

.card-vehicle-analytic-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 9px;
}
.template-grid .template-grid-content {
  display: grid;
  grid-template-rows: 100px 1fr;
  grid-column-gap: 8px;
  height: calc(100vh - 130px);
  overflow-y: hidden;
  overflow-x: auto;
}
.template-grid .template-grid-content > div {
  /* border:1px solid red */
}
</style>
